import React from 'react';
import { clsx } from 'clsx';

type BadgeVariant = 'default' | 'success' | 'error' | 'warning' | 'info' | 'muted';

interface BadgeProps {
  variant?: BadgeVariant;
  className?: string;
  children: React.ReactNode;
}

const variantStyles: Record<BadgeVariant, string> = {
  default: 'bg-tg-bg-tertiary text-tg-text',
  success: 'text-white',
  error: 'text-white',
  warning: 'text-white',
  info: 'text-white',
  muted: 'text-tg-text-secondary',
};

const variantInlineStyles: Record<BadgeVariant, React.CSSProperties> = {
  default: {},
  success: { background: 'var(--tg-success)' },
  error: { background: 'var(--tg-error)' },
  warning: { background: 'var(--tg-warning)' },
  info: { background: 'var(--tg-accent)' },
  muted: { background: 'var(--tg-border)' },
};

export function Badge({ variant = 'default', className, children }: BadgeProps) {
  return (
    <span
      className={clsx(
        'inline-flex items-center px-2 py-0.5 rounded text-xs font-medium',
        variantStyles[variant],
        className
      )}
      style={variantInlineStyles[variant]}
    >
      {children}
    </span>
  );
}
